@if (loading()) {
	<div class="spin-wrapper"><nz-spin nzSimple nzSize="large"></nz-spin></div>
}

@if (!loading() && token() && userId() && (takeNumber() || dontTrackTake()) && course() && safeUrl()) {
	<div class="wrapper">
		<iframe
			[src]="safeUrl() | safe: 'resourceUrl'"
			allow="
				microphone *;
				encrypted-media *;
				fullscreen *;
				speaker-selection *;
				unsized-media *;
				camera *;
				display-capture *;
				clipboard-write *;
				clipboard-read *;
			"
			#iframe
		></iframe>
	</div>
}
